import { IEndUsersCountStatsByDate } from '../interfaces/Stats';

export const MONTHS = [
	'Jan',
	'Feb',
	'Mar',
	'Apr',
	'May',
	'Jun',
	'Jul',
	'Aug',
	'Sep',
	'Oct',
	'Nov',
	'Dec',
];

export const INIT_USERS_STATS: IEndUsersCountStatsByDate = {
	datesRangeUnit: 'w',
	stats: [],
};
